import { useEffect, useState } from 'react';

import { isBareboneProjectId } from 'src/data/project';

import { useListViewActions } from '../store';

export const useQueryGenerationResults = (projectId) => {
  const listViewActions = useListViewActions();
  const [shouldQuery, setShouldQuery] = useState(true);

  useEffect(() => {
    if (!projectId || isBareboneProjectId(projectId)) {
      return;
    }

    const results = listViewActions.queryGenerationResults();
    if (results?.[0]?.isGenerating) {
      if (shouldQuery) {
        setTimeout(() => {
          listViewActions.queryGenerationResults();
        }, 2000);
      }
    }

    return () => {
      setShouldQuery(false);
    };
  }, [listViewActions, projectId, shouldQuery]);
};
